import SigliveServiceV1 from 'Service/sigliveServiceV1';

const patchLiveAccount = async ({ payload, id }) => {
  const { data } = await SigliveServiceV1({ method: 'PATCH', url: `/account-livestream/${id}`, data: payload });

  return data;
};

export default patchLiveAccount;
